module.exports = __webpack_public_path__ + "media/application/images/404-bg-5d29f30b961f4320a0a556a6d8700c24.png";